export default __webpack_public_path__ + "static/media/jamLogo.e84a7f73.png";